import React from 'react'
import useStyles from './ResetPasswordConfirmationStyles';
import ResetPasswordConfirmationCard from '@/components/ResetPasswordConfirmationCard/ResetPasswordConfirmationCard';

const ResetPasswordConfirmation: React.FC = () => {

    const { classes, cx } = useStyles();

    React.useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, []);

    return (
        <ResetPasswordConfirmationCard />
    )
}

export default ResetPasswordConfirmation
